export default theme => ({
    buttons: {
        display: 'block',
        position: 'relative',
        marginBottom: 30,
        width: 'calc(100% + 12px)',
        marginLeft: -6,
        marginRight: -6,
        '& > a': {
            margin: 6,
        }
    },
})